// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__sCifs","topBottomGutter":"Layout_topBottomGutter__1ztmM"};